import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import HotComics from './components/HotComics';
import FeatureGrid from './components/FeatureGrid';
import NewArrivals from './components/NewArrivals';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';
import CategoriesNav from './components/CategoriesNav';
import { faqs } from '@/mocks/comics';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '36漫画网',
  url: 'http://jhequip.com/',
  description: '36漫画网提供无删减韩国漫画下拉式阅读，免费韩漫大全涵盖各类热门作品。',
  foundingDate: '2020',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'hello@jhequip.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '36漫画网',
  url: 'http://jhequip.com/',
  description: '36漫画网提供无删减韩国漫画下拉式阅读，免费韩漫大全涵盖各类热门作品，界面简洁、操作简单。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://jhequip.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '韩国漫画无删减漫画下拉式-免费韩漫大全-36漫画网',
  description: '36漫画网提供无删减韩国漫画下拉式阅读，免费韩漫大全涵盖各类热门作品，界面简洁、操作简单，让您快速找到并阅读喜爱的韩漫。',
  url: 'http://jhequip.com/',
  inLanguage: 'zh-CN',
  isPartOf: {
    '@type': 'WebSite',
    name: '36漫画网',
    url: 'http://jhequip.com/',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webpageSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>

      <Navbar transparent />

      <main>
        <HeroBanner />
        <CategoriesNav />
        <HotComics />
        <FeatureGrid />
        <NewArrivals />
        <Testimonials />
        <CTASection />

        <section className="py-14 md:py-20 bg-background-50">
          <div className="mx-auto px-4 md:px-6 max-w-3xl">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 border border-background-300 rounded-full text-foreground-600 text-xs font-medium mb-4 whitespace-nowrap">
                常见问题
              </span>
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
                关于36漫画网的
                <span className="block">常见问题解答</span>
              </h2>
            </div>
            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-xl overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <span className="text-foreground-900 font-medium text-sm pr-4">{faq.question}</span>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}